<template>
  <div class="modal_user">
    <div class="modal_user__header">
      <h4 class="title">
        {{ primary_data.id? primary_data.name : translate('user.add') }}
      </h4>
    </div>
    <div class="modal_user__body">
      <div class="user">
        <div class="tab">
          <span class="tab_title" :class="{ active : block==='MainInfo'}" @click="selected_block('MainInfo')">{{this.translate('user.main_info.title')}}</span>
          <span class="tab_title" v-if="primary_data.id" :class="{ active : block==='Groups'}" @click="selected_block('Groups')">{{this.translate('user.groups/list .title')}}</span>
          <span class="tab_title" v-if="primary_data.id" :class="{ active : block==='RoleManagement'}" @click="selected_block('RoleManagement')">{{this.translate('user.role_manage.title')}}</span>
          <span class="tab_title" v-if="primary_data.id" :class="{ active : block==='Comments'}" @click="selected_block('Comments')">{{this.translate('user.comments.title')}}</span>
        </div>
        <div class="block">
          <MainInfo v-if="block==='MainInfo'" :main_info="main_info" :client_ids="client_ids" @update_user="update_user"/>
          <Groups v-if="block==='Groups'" :user="primary_data" @update_groups="update_groups"/>
          <RoleManagement v-if="block==='RoleManagement'" :user_id="primary_data.id" />
          <Comments v-if="block==='Comments'" :params="comments_params" />
        </div>
      </div>


    </div>
    <div class="modal_user__footer">
      <div class="text-center">
        <button
          type="submit"
          class="btn btn-danger btn-fill btn-wd marginButton"
          @click.prevent="cancel"
        >
          {{ translate('close_modal') }}
        </button>
      </div>
    </div>

  </div>
</template>
<script>

import MainInfo from "./Tabs/MainInfo";
import Groups from "./Tabs/Groups.vue";
import RoleManagement from "./Tabs/RoleManagement.vue";
import Comments from "@/views/Dashboard/common/General/Summary/Comments.vue";

export default {
  name: 'EditUserProfile',
  props: ['user', 'client_ids'],
  components: {
    MainInfo,
    Groups,
    RoleManagement,
    Comments
  },
  data () {
    return {
      block: 'MainInfo',
      disabled_btn: false,
      primary_data: {
        name: ''
      },
    }
  },
  created() {
    this.init()

    this.primary_data = {...this.user}
  },

  destroyed(){
    this.close_modal()
  },

  computed:{
    main_info(){
      let user_info = {...this.primary_data}
      delete(user_info.roles)
      delete(user_info.group)
      return user_info
    },
    comments_params(){ return {user_id: this.primary_data.id} }
  },

  methods: {
    update_user(data){
      this.primary_data = data
      this.$emit('update')
    },
    update_groups(groups){
      this.primary_data.group = groups
      this.$emit('update')
    },
    cancel () {
      this.$emit('close')
    },
    selected_block(block){
      this.block = block
    },
    init(){
      if (!this.$route.params.user_id) {
        this.old_url = this.$route.fullPath
        history.pushState(null, null, window.location.href + '/@' + this.user.username)
      }
    },
    close_modal () {
      if (this.$route.params.user_id) {
        let new_window = this.$route.fullPath.replace('/'+ this.$route.params.user_id, '')
        this.$router.push(new_window)
      }else{
        this.$router.push(this.old_url)
      }
      this.$emit('close')
    }
  }
}

</script>

<style lang='scss' scoped>
  .modal_user{
    height: 100%;
    padding: 10px;
    &__header{
      height: 5%;
      .title{
        margin: 0 0 10px 0;
        text-align: center;
      }
    }
    &__body{
      width: 100%;
      height: 90%;
      .loading{
        border:none;
        background-color: transparent;
      }
      .user{
        width: 100%;
        height: 100%;
        .tab{
          width: 100%;
          height: 5%;
          display: flex;
          align-content: center;
          justify-content: center;
          flex-direction: row;
          &_title{
            width: 100%;
            padding: 5px 0;
            cursor: pointer;
            font-weight: 600;
            text-align: center;
            background-color: #efe9e9;
            border: 1px solid #efe9e9;
            &.active{
              background-color: #FFFFFF;
              border-bottom: 1px solid white;
            }
          }
        }
        .block{
          height: 95%;
          border: 1px solid #efe9e9;
          margin-top: -1px;
          padding: 10px;
        }
      }

    }
    &__footer{
      height: 5%;
    }
  }
  .pointer{
    cursor: pointer;
    &:hover{
      background-color: #f3f3f3;
    }
  }


</style>
